import { Typography } from '@mui/material'

const HeadingTitle = ({ children }) => (
  <Typography variant="h3">
    {children}
  </Typography>
)

export default HeadingTitle
